export enum LocalStorageKeys {
  FUNNEL_CACHE = 'funnelCache',
  AUTH_TOKEN = 'AuthToken',
  SSE_TOKEN = 'SSEToken',
  MEMBER_TOKEN = 'MemberToken',
  MEMBER_STATE = 'MemberState',
  PATIENT_STATE = 'PatientState',
  CUSTOMER_STATE = 'CustomerState',
  CART_STATE = 'CartState',
  CHECKOUT_STATE = 'CheckoutState',
  DOCTOR_STATE = 'DoctorState',
  CART_CLIENT_ID = 'CartClientId',
  GEOLOCATION_STATE = 'GeolocationState',
}
